import { useStateSelector } from './useStateSelector';

export const useToken = () =>
  useStateSelector((state) => state.settings.access_token);
